import { type RequestPayload, router } from "@inertiajs/core";
import { ApprenticeForm } from "../../../components/apprentice/ApprenticeForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { ApprenticeSupervisor } from "../../../models/apprenticeSupervisor";
import type { Company } from "../../../models/company";
import type { Group } from "../../../models/group";
import type { School } from "../../../models/school";
import type { YearContext } from "../../../models/yearContext";
import { apprentices_path } from "../../../routes";

type ApprenticeCreateProps = {
  apprentice_supervisors: ApprenticeSupervisor[];
  companies: Company[];
  year_contexts: YearContext[];
  groups: Group[];
  schools: School[];
};

export default function ApprenticeCreate({ apprentice_supervisors, companies, year_contexts, groups, schools }: ApprenticeCreateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(apprentices_path), values);

  return (
    <ContentShell title="Neue Lernende/r" onBack={() => router.get(pathWithYearContext(apprentices_path))}>
      <ApprenticeForm
        groups={groups}
        schools={schools}
        onSubmit={onSubmit}
        yearContexts={year_contexts}
        submitButtonLabel="Erstellen"
        companies={companies}
        apprentice_supervisors={apprentice_supervisors}
      />
    </ContentShell>
  );
}
